import { render } from "./examens_config_page.vue?vue&type=template&id=214141a8"
import script from "./examens_config_page.vue?vue&type=script&lang=js"
export * from "./examens_config_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__